export const compareVersions = (version1: string, version2: string): number => {
  const v1Parts = version1.split('.').map(Number);
  const v2Parts = version2.split('.').map(Number);

  const maxLength = Math.max(v1Parts.length, v2Parts.length);

  for (let i = 0; i < maxLength; i++) {
    const v1Part = v1Parts[i] || 0;
    const v2Part = v2Parts[i] || 0;

    if (v1Part > v2Part) return 1;
    if (v1Part < v2Part) return -1;
  }

  return 0;
};

export const checkSyncAppEligibilityForTruelark = (syncAppInfo: { name: string; version: string }) => {
  const name = syncAppInfo.name?.toLowerCase() ?? '';
  const version = syncAppInfo.version?.toLowerCase() ?? '';
  // version can include extra characters like 'version 16.2.1' so extract the numeric part
  const versionMatch = version.match(/(\d+(\.\d+)*)/);
  const extractedVersion = versionMatch ? versionMatch[1] : '';

  if (!name || !extractedVersion) {
    return false;
  }

  if (name.includes('opendental')) {
    // all versions
    return true;
  } else if (name.includes('dentrix')) {
    // allow 16.2 and above
    return compareVersions(extractedVersion, '16.2') >= 0;
  } else if (name.includes('eaglesoft')) {
    // allow 18/19/20/21, 18+, 19, 22
    if (compareVersions(extractedVersion, '18') >= 0 && compareVersions(extractedVersion, '23') < 0) {
      return true;
    }
  }
  return false;
};
